import React, { useEffect } from "react";

// Rutas
import { NavLink } from "react-router"

// Material UI
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
// import Grid from '@mui/material/Grid';
import { Button, Grid } from "@mui/material"
import Card from '@mui/material/Card';

// Icons
import { Settings } from "@mui/icons-material"

import { useTablon } from "../contexts/contextGeneral";

import Orden from "../components/Ordenes/orden";

function Ordenes(params) {
    const { ordenes, getOrdenes } = useTablon()

    React.useEffect(() => {
        getOrdenes()
        // eslint-disable-next-line
    }, [])

    return (
        <>
            <Grid container spacing={3}>
                <Grid size={{ xs: 12, md: 12 }} >
                    <NavLink to="/ordenes/addneworder">
                        <Card className={"centerH"}>
                            <Button variant="contained" size="large" color="primary" fullWidth >
                                Crear Nueva Orden
                            </Button>
                        </Card>
                    </NavLink>
                </Grid>
                {ordenes !== null && ordenes.map((data, i) => {
                    return (
                        <Grid key={i} size={{ xs: 12, md: 6 }}>
                            <Orden data={data} />
                        </Grid>
                    )
                })}
            </Grid>

        </>
    )
}

export default Ordenes